interface AddOnIdentity {
  id?: string | null;
  add_on_id?: string | null;
  name?: string | null;
}

function normalizeAddOnName(name?: string | null) {
  const normalizedName = name?.trim().toLowerCase().replace(/\s+/g, " ") ?? "";

  if (!normalizedName) {
    return "";
  }

  const sanitizedName = normalizedName
    .replace(/\([^)]*\)/g, "")
    .replace(/\blive\b/g, "")
    .replace(/\s+/g, " ")
    .trim();

  if (sanitizedName === "custom music mix" || sanitizedName === "custom mix") {
    return "custom mix";
  }

  if (sanitizedName === "virtual practice") {
    return "virtual practice";
  }

  return sanitizedName;
}

export function getAddOnIdentityKey(addOn: AddOnIdentity) {
  const normalizedName = normalizeAddOnName(addOn.name);

  if (normalizedName) {
    return `name:${normalizedName}`;
  }

  const id = addOn.id ?? addOn.add_on_id;
  return id ? `id:${id}` : "";
}

export function isSameAddOn(a: AddOnIdentity, b: AddOnIdentity) {
  const aId = a.id ?? a.add_on_id;
  const bId = b.id ?? b.add_on_id;

  if (aId && bId && aId === bId) {
    return true;
  }

  const aKey = getAddOnIdentityKey(a);
  const bKey = getAddOnIdentityKey(b);

  return aKey.length > 0 && aKey === bKey;
}
